import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import {DeploymentEnvironment} from './deployment.ts'

/* fetch('/__/firebase/init.json').then(response => {
	firebase.initializeApp(response.json());
}); */

if (!firebase.apps.length) {

  const productionConfig = {
    apiKey: "AIzaSyBtnKEFmkQ6GrHH0IMFg_yvRlqOD6fSCa0",
    authDomain: "smartclipid.firebaseapp.com",
    databaseURL: "https://smartclipid.firebaseio.com",
    projectId: "smartclipid",
    storageBucket: "smartclipid.appspot.com",
    messagingSenderId: "1084086527529", 
  }

  const stagingConfig = {
    apiKey: "AIzaSyBKUi9xtWbdYyAOfJwvEmK2Zsw92kzq5kQ",
    authDomain: "smartclip-codama.firebaseapp.com",
    projectId: "smartclip-codama",
    storageBucket: "smartclip-codama.appspot.com",
    messagingSenderId: "595543586016",
    appId: "1:595543586016:web:2e181f8d4daf730d4e4c85",
    measurementId: "G-WF7QHKV5JN",
    databaseURL: "https://smartclip-codama.firebaseio.com", 
  }
  const config = DeploymentEnvironment === 'staging' ? stagingConfig : productionConfig

  firebase.initializeApp(config);

  if (process.env.NODE_ENV === "development") {
    // firebase.auth().useEmulator("http://localhost:9099");
    // firebase.firestore().useEmulator("127.0.0.1", 8080);
    // firebase.functions().useEmulator("127.0.0.1", 5001);
    // firebase.storage().useEmulator("127.0.0.1", 9199);
  }

  if (process.env.NODE_ENV === "production") {
    firebase.firestore().enablePersistence();
  }
}
